import type { IconData } from '@stacksjs/iconify-core'

export const mapFold: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M16.84 5c-4.587.609-8.783 1.998-11.205 2.917c-1.349.512-2.229 1.77-2.305 3.21C3.19 13.781 3 18.706 3 25.9c0 6.878.174 11.682.312 14.41c.067 1.341 1.427 2.189 2.694 1.744C12.036 39.936 16.84 39.2 16.84 39.2C24 40.15 31.159 43 31.159 43c4.588-.609 8.784-1.998 11.206-2.917c1.349-.512 2.229-1.77 2.305-3.21c.14-2.655.33-7.579.33-14.773c0-6.878-.174-11.682-.312-14.41c-.067-1.341-1.427-2.189-2.694-1.744C35.964 8.064 31.16 8.8 31.16 8.8C24 5.95 16.841 5 16.841 5Zm-.19 34.151V5.126m14.7 3.724v34.025\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mapFold
